var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "pui-lightbox",
    {
      ref: _vm.REF_CONSTANTS.LIGHTBOX,
      attrs: {
        "default-header-label": _vm.lightboxTitle,
        "default-footer-cancel-label": _vm.$t("thresholdsTab.modal.cancel"),
        "default-footer-confirm-label": _vm.$t("thresholdsTab.modal.save"),
        "default-footer-confirm-disabled": !_vm.isFormSubmittable,
        "on-confirm-callback": _vm.lightboxConfirm,
        "on-before-close-callback": _vm.lightboxBeforeClose,
        "fit-content": true,
      },
    },
    [
      _c(
        "pui-loader",
        { attrs: { promise: _vm.thresholdPromise } },
        [
          _c(
            "pui-form",
            {
              staticClass: "threshold-form",
              attrs: {
                notifications: _vm.errorNotifications,
                "aria-label": "threshold-form",
              },
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "pui-form-grid-row",
                      rawName: "v-pui-form-grid-row",
                    },
                  ],
                },
                [
                  _c(
                    "pui-form-group",
                    {
                      directives: [
                        {
                          name: "pui-form-grid-column",
                          rawName: "v-pui-form-grid-column",
                          value: _vm.GRID_COLUMN_SPAN.ONE_SIXTH,
                          expression: "GRID_COLUMN_SPAN.ONE_SIXTH",
                        },
                      ],
                      attrs: {
                        label: _vm.$t(_vm.formData.labels.lowerThreshold),
                        "is-valid": _vm.formData.validation.lowerThreshold,
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "error-message",
                          fn: function () {
                            return [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.formData.errorMessages.lowerThreshold
                                  ) +
                                  " "
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ]),
                    },
                    [
                      _c("pui-form-input-field", {
                        attrs: {
                          "is-valid": _vm.formData.validation.lowerThreshold,
                          required: true,
                          min: _vm.MIN_THRESHOLD_VALUE,
                          max: _vm.MAX_THRESHOLD_VALUE,
                          step: _vm.THRESHOLD_STEP,
                          type: "number",
                        },
                        on: { input: _vm.validateForm },
                        model: {
                          value: _vm.formData.values.lowerThreshold,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData.values, "lowerThreshold", $$v)
                          },
                          expression: "formData.values.lowerThreshold",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "pui-form-group",
                    {
                      directives: [
                        {
                          name: "pui-form-grid-column",
                          rawName: "v-pui-form-grid-column",
                          value: _vm.GRID_COLUMN_SPAN.ONE_SIXTH,
                          expression: "GRID_COLUMN_SPAN.ONE_SIXTH",
                        },
                      ],
                      attrs: {
                        label: _vm.$t(_vm.formData.labels.upperThreshold),
                        "is-valid": _vm.formData.validation.upperThreshold,
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "error-message",
                          fn: function () {
                            return [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.formData.errorMessages.upperThreshold
                                  ) +
                                  " "
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ]),
                    },
                    [
                      _c("pui-form-input-field", {
                        attrs: {
                          "is-valid": _vm.formData.validation.upperThreshold,
                          required: true,
                          min: _vm.MIN_THRESHOLD_VALUE,
                          max: _vm.MAX_THRESHOLD_VALUE,
                          step: _vm.THRESHOLD_STEP,
                          type: "number",
                        },
                        on: { input: _vm.validateForm },
                        model: {
                          value: _vm.formData.values.upperThreshold,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData.values, "upperThreshold", $$v)
                          },
                          expression: "formData.values.upperThreshold",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "pui-form-group",
                    {
                      directives: [
                        {
                          name: "pui-form-grid-column",
                          rawName: "v-pui-form-grid-column",
                          value: _vm.GRID_COLUMN_SPAN.ONE_THIRD,
                          expression: "GRID_COLUMN_SPAN.ONE_THIRD",
                        },
                      ],
                      attrs: {
                        label: _vm.$t(_vm.formData.labels.validFrom),
                        "is-valid": _vm.formData.validation.validFrom,
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "error-message",
                          fn: function () {
                            return [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.formData.errorMessages.validFrom) +
                                  " "
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ]),
                    },
                    [
                      _c("pui-form-input-field", {
                        attrs: {
                          "is-valid": _vm.formData.validation.validFrom,
                          required: true,
                          type: "date",
                        },
                        on: { input: _vm.validateForm },
                        model: {
                          value: _vm.formData.values.validFrom,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData.values, "validFrom", $$v)
                          },
                          expression: "formData.values.validFrom",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "pui-form-group",
                    {
                      directives: [
                        {
                          name: "pui-form-grid-column",
                          rawName: "v-pui-form-grid-column",
                          value: _vm.GRID_COLUMN_SPAN.ONE_THIRD,
                          expression: "GRID_COLUMN_SPAN.ONE_THIRD",
                        },
                      ],
                      attrs: {
                        label: _vm.$t(_vm.formData.labels.validTo),
                        "is-valid": _vm.formData.validation.validTo,
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "error-message",
                          fn: function () {
                            return [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.formData.errorMessages.validTo) +
                                  " "
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ]),
                    },
                    [
                      _c("pui-form-input-field", {
                        attrs: {
                          "is-valid": _vm.formData.validation.validTo,
                          required: true,
                          type: "date",
                        },
                        on: { input: _vm.validateForm },
                        model: {
                          value: _vm.formData.values.validTo,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData.values, "validTo", $$v)
                          },
                          expression: "formData.values.validTo",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }